import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import * as initialSelectors from './selectors';
import type { IProductsContextValue } from './types';

export default createContext<IProductsContextValue>({
  state: initialState,
  actions: initialActionsState,
  selectors: initialSelectors,
});
